/**
 * Calculates the cost of a collateral item in cents.
 * 
 * @param {Object} pricingInfo - The pricing info object from the collateral template.
 * @param {number} quantity - The quantity being ordered.
 * @returns {number} The total cost in cents.
 */
export const calculateCollateralCostCents = (pricingInfo, quantity) => {
    if (!pricingInfo) return 0;

    const prices = pricingInfo.prices || pricingInfo;
    const tiers = Object.keys(prices).map(Number).sort((a, b) => b - a);
    const matchingTier = tiers.find((tier) => quantity >= tier) || tiers[tiers.length - 1];

    const pricePerUnit = prices[matchingTier] || 0;
    const itemsPerUnit = pricingInfo.items_per_unit || 1;

    return Math.round(pricePerUnit * itemsPerUnit * quantity * 100);
};
